<script>
    import DateComponent from "../../DateComponent.svelte";
    import Tag from "../../Tag.svelte";
    import AdditionalLabel from "../../AdditionalLabel.svelte";

    export let fixPublication;
    export let feed_tags;
    export let pub_start_date;
    export let additional_content = false;
</script>

<span class="top-panel">
    <section class="left-content">
        {#if fixPublication}
            <i class="icon-pin dot" />
        {/if}

        {#each feed_tags as feed_tag, index}
            <Tag {...feed_tag} {pub_start_date} {index} count={feed_tags.length} />
        {/each} 

        {#if pub_start_date}
            <div class="date">
                <DateComponent createdDate={pub_start_date} />
            </div>
        {/if}
    </section>

    {#if additional_content}
        <AdditionalLabel />
    {/if}
</span>

<style lang="scss">
    .left-content {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .date {
        font-size: 10px;
        line-height: 18px;
    }
    
    .icon-pin {
        font-size: 12px;
    }

    .icon-pin::before {
        margin: 0;
    }

    .top-panel {
        display: flex;
        flex-direction: row;
        padding-bottom: 16px;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: space-between;

        @media (min-width: 320px) and (max-width: 1000px) {
            padding-top: 16px;
            flex-direction: column;
            align-items: start;
            gap: 8px;
        }
    }
</style>